import { createContext } from 'react';

const DynamicModulesContext = createContext();

export default DynamicModulesContext
